import Model from "./model";
import store from '@/store'

export default new Model({
  resource: "labor",
  inputs:[
    {label:"ID", nameAttr:"id", default:0, required: true, type:"text", width: 60},
    {label:"Nombre", nameAttr:"nombre", default:"", required: true, type:"text", width: 300},
    {label:"Código", nameAttr:"codigo", default:"-", required: true, type:"text", width: 100},
    {label:"Descripción", nameAttr:"descripcion", default:"-", required: false, type:"text", width: 300},
    {label:"Empresa", nameAttr:"empresa_id", default:null, required: true, type:"select", model:"empresaModel", searchPath:"nombre", width:150,
      mapValueFn:(itemForm, item) => {
        itemForm.list = _.filter(itemForm.list, item => {
          return _.find(store.getters.empresas, {id: item.id})
        })
        return itemForm;
      },
    },
  ]

});
